import { ChangeDetectionStrategy, Component, Input, OnInit, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConversationChannel, GlobalParticipantType, SubjectParticipant } from '@vendasta/conversation';
import { Observable, map, shareReplay } from 'rxjs';
import { ConversationListService } from '../../../../core/src/lib/conversation-list.service';
import { ConversationService } from '../../../../core/src/lib/conversation.service';
import { FirestoreService } from '../../../../core/src/lib/firestore.service';
import { InboxNavigationService } from '../../../../core/src/lib/inbox-navigation.service';
import { InboxService } from '../../../../core/src/lib/inbox.service';
import { ConversationDetail } from '../../../../core/src/lib/interface/conversation.interface';
import { CONVERSATION_ROUTES_TOKEN } from '../../../../core/src/lib/tokens';
import { INBOX_NAVIGATION_LINK } from '../../constants';

@Component({
  selector: 'inbox-pane-preview',
  styleUrls: ['./inbox-pane-preview.component.scss'],
  templateUrl: './inbox-pane-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InboxPanePreviewComponent implements OnInit {
  private readonly conversationService = inject(ConversationService);
  private readonly conversationListService = inject(ConversationListService);
  private readonly inboxService = inject(InboxService);
  private readonly firestoreService = inject(FirestoreService);
  private readonly inboxNav = inject(InboxNavigationService);

  displayBadge = this.inboxService.isPartnerCenter;

  showInboxPreviewPane: boolean;

  @Input() partnerId = '';
  @Input() accountGroupId = '';

  conversations$: Observable<ConversationDetail[]>;
  showEmptyState$: Observable<boolean>;

  private readonly routes = toSignal(inject(CONVERSATION_ROUTES_TOKEN));
  readonly useInboxModal = computed(() => this.routes().useModal);
  readonly inboxRoute = computed(() => {
    const root = `${this.routes().root}/inbox/`;
    return this.useInboxModal() ? INBOX_NAVIGATION_LINK : [root];
  });

  ngOnInit(): void {
    this.showInboxPreviewPane = this.partnerId !== 'VMF';
    this.conversations$ = this.conversationListService
      .fetchConversations(this.firestoreService.loadOrgRelatedConversationsQuery(this.accountGroupId))
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));
    this.showEmptyState$ = this.conversations$.pipe(map((conversations) => conversations.length === 0));
  }

  trackConversationDetailsById(i: number, conversationDetail: ConversationDetail): string | undefined {
    return conversationDetail?.conversation?.conversationId;
  }

  startNewMessage(): void {
    this.inboxNav.gotoConversationChannel(
      [
        new SubjectParticipant({
          internalParticipantId: this.partnerId,
          participantType: GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_PARTNER,
        }),
        new SubjectParticipant({
          internalParticipantId: this.accountGroupId,
          participantType: GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_ACCOUNT_GROUP,
        }),
      ],
      ConversationChannel.CONVERSATION_CHANNEL_INTERNAL,
    );
  }
}
